<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="back-title"><b>Table of Contents</b></p>
<p class="toc1"><a href="#/intro">Introduction</a></p>
<p class="toc"><a href="#/chap1">Ch. 1  Connecticut's Hatcheries &amp; Stocking Program</a></p>
<p class="toc"><span href="#/chap2" title="Link target outside of Sample">Ch. 2  Connecticut's Trout Streams &amp; Rivers</span></p>
<p class="toc"><span href="#/chap3" title="Link target outside of Sample">Ch. 3  Trout &amp; Their Habits</span></p>
<p class="toc"><span href="#/chap4" title="Link target outside of Sample">Ch. 4  Getting Ready</span></p>
<p class="toc"><span href="#/chap5" title="Link target outside of Sample">Ch. 5  Hitting the Stream</span></p>
<p class="toc"><span href="#/chap6" title="Link target outside of Sample">Ch. 6  Fishing Conservation &amp; Etiquette</span></p>
<p class="toc"><span href="#/chap7" title="Link target outside of Sample">Ch. 7  Trout Food</span></p>
<p class="toc"><span href="#/chap8" title="Link target outside of Sample">Ch. 8  Finding Fish</span></p>
<p class="toc"><span href="#/chap9" title="Link target outside of Sample">Ch. 9  Cooking Your Catch</span></p>
<p class="toc1"><span href="#/gls" title="Link target outside of Sample">An Angler's Glossary</span></p>
<p class="toc1"><span href="#/ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/websites" title="Link target outside of Sample">A Few Recommended Web Sites</span></p>
<p class="toc1"><span href="#/back" title="Link target outside of Sample">Fly Fishing Canon</span></p>
<p class="toc1"><span href="#/illu" title="Link target outside of Sample">Illustration Credits</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3868dc97